/**
 * Users — shared constants. Phase 7 extract from pages/Users.jsx.
 *
 * Single source of truth so the Invite and Edit dialogs stay in sync if a
 * new role is ever added.
 */

export const ROLE_LABELS = {
    super_admin: "Super Admin",
    org_admin: "Org Admin",
    entity_admin: "Entity Admin",
    entity_viewer: "Entity Viewer",
    viewer: "Viewer",
};

// SA can grant any role (including SA→SA). Non-SA can only grant org_admin
// and below. Order = display order in the dropdown.
export const ROLE_OPTIONS_FOR = (myRole) => {
    const all = [
        { value: "super_admin",   label: "Super Admin · cross-tenant" },
        { value: "org_admin",     label: "Org Admin · full control" },
        { value: "entity_admin",  label: "Entity Admin · team control" },
        { value: "entity_viewer", label: "Entity Viewer · create & view" },
        { value: "viewer",        label: "Viewer · read only" },
    ];
    return myRole === "super_admin" ? all : all.filter((o) => o.value !== "super_admin");
};

export const EMAIL_RE = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
export const BLANK_INVITE = { email: "", name: "", role: "viewer", org_id: "", tenant_id: "", sso_required: false, sso_provider: "" };

export const SORT_FIELDS = {
    name: (u) => (u.name || "").toLowerCase(),
    email: (u) => (u.email || "").toLowerCase(),
    role: (u) => ROLE_LABELS[u.role] || u.role,
    org_name: (u) => (u.org_name || "").toLowerCase(),
    tenant_name: (u) => (u.tenant_name || "").toLowerCase(),
    created_at: (u) => u.created_at || "",
    last_login_at: (u) => u.last_login_at || "",
    is_active: (u) => (u.is_active ? 1 : 0),
    sso_required: (u) => (u.sso_required ? 1 : 0),
};
